import { useDispatch } from 'react-redux';
import { Button, Text } from '@rsos/base-components';
import {
  closeResourcePanel,
  setResourcePanelView,
  useBreadCrumbs,
} from '@rsos/reduxDataStore/src/features/resourceRequests';
import type { ResourceRequestDetailView } from '../adapters';
import type { ResourceOption } from '../types';
import ResourceOptionCard from './ResourceOptionCard';
import {
  PanelListHeader,
  HeaderRow,
  PanelContent,
  PanelFooter,
} from './ResourceRequestPanel.styles';

interface NewRequestViewProps {
  resourceOptions: readonly ResourceOption[];
  onResourceClick: (resourceId: ResourceRequestDetailView) => void;
}

function NewRequestView({
  resourceOptions,
  onResourceClick,
}: NewRequestViewProps) {
  const breadCrumbs = useBreadCrumbs();
  const dispatch = useDispatch();
  const handleCloseResourcePanel = () => {
    if (breadCrumbs.includes('list_requests') && breadCrumbs.length > 1) {
      dispatch(setResourcePanelView('list_requests'));
    } else {
      dispatch(closeResourcePanel());
    }
  };

  return (
    <>
      <PanelListHeader>
        <HeaderRow>
          <div>
            <Text
              color="primaryText"
              fontWeight="bold"
              size="large"
              lineHeight="1.2"
              data-name="resource-panel-title"
            >
              New Resource Request
            </Text>
            <Text
              color="secondaryText"
              size="normal"
              marginTop="4px"
              data-name="resource-panel-subtitle"
            >
              Choose a resource type to request
            </Text>
          </div>
        </HeaderRow>
      </PanelListHeader>
      <PanelContent>
        {resourceOptions.map(option => (
          <ResourceOptionCard
            key={option.id}
            option={option}
            onClick={() => onResourceClick(option.id)}
          />
        ))}
      </PanelContent>

      <PanelFooter>
        <Button
          btnType="secondary"
          grow
          noMargin
          onClick={handleCloseResourcePanel}
          dataName="resource-panel-cancel-button"
        >
          Cancel
        </Button>
      </PanelFooter>
    </>
  );
}

export default NewRequestView;
